import {FC} from 'react';

const JPGIcon: FC = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
      width="24px"
      height="24px"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0" />

      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />

      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          style={{fill: '#0076CF'}}
          d="M511.344,274.266C511.77,268.231,512,262.143,512,256C512,114.615,397.385,0,256,0S0,114.615,0,256 c0,117.769,79.53,216.949,187.809,246.801L511.344,274.266z"
        />{' '}
        <path
          style={{fill: '#00477D'}}
          d="M511.344,274.266L314.991,77.913L119.096,434.087l68.714,68.714C209.522,508.787,232.385,512,256,512 C391.243,512,501.976,407.125,511.344,274.266z"
        />{' '}
        <polygon style={{fill: '#FFFFFF'}} points="278.328,333.913 255.711,77.913 119.096,77.913 119.096,311.652 " />{' '}
        <polygon
          style={{fill: '#E8E6E6'}}
          points="392.904,311.652 392.904,155.826 337.252,133.565 314.991,77.913 255.711,77.913 256.067,333.913 "
        />{' '}
        <polygon style={{fill: '#FFFFFF'}} points="314.991,155.826 314.991,77.913 392.904,155.826 " />{' '}
        <rect x="119.096" y="311.652" style={{fill: '#3CA8FA'}} width="273.809" height="122.435" />{' '}
        <g>
          {' '}
          <path
            style={{fill: '#FFFFFF'}}
            d="M216.147,382.182c0,11.276-7.039,17.785-18.315,17.785c-7.491,0-13.546-3.103-18.238-8.476 l6.205-9.006c3.784,3.936,8.022,5.904,11.125,5.904c3.557,0,5.677-2.195,5.677-6.509v-24.672h-18.163v-10.898h31.709 L216.147,382.182L216.147,382.182z"
          />{' '}
          <path
            style={{fill: '#FFFFFF'}}
            d="M250.813,346.387c13.547,0,21.341,6.659,21.341,18.465c0,12.412-7.795,19.601-21.341,19.601h-9.611 v14.909H227.73v-52.975L250.813,346.387L250.813,346.387z M241.202,373.858h8.929c5.904,0,9.308-2.952,9.308-8.552 c0-5.525-3.406-8.324-9.308-8.324h-8.929V373.858z"
          />{' '}
          <path
            style={{fill: '#FFFFFF'}}
            d="M327.935,372.42v20.66c-5.677,4.011-14.606,6.888-22.023,6.888 c-16.119,0-28.304-11.655-28.304-27.094c0-15.362,12.487-26.941,29.212-26.941c7.87,0,16.195,3.027,21.644,7.87l-7.569,9.157 c-3.86-3.557-9.233-5.751-14.152-5.751c-8.703,0-15.363,6.811-15.363,15.665c0,9.006,6.736,15.817,15.514,15.817 c2.725,0,6.206-0.984,9.385-2.573V372.42H327.935z"
          />{' '}
        </g>{' '}
      </g>
    </svg>
  );
};

export default JPGIcon;
